export default __webpack_public_path__ + "static/media/clube_do_parque.06f1a91c.jpg";